import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import userStore from "@/store/user";
import rdo from "./rdo";
import pos_vendas from "./pos_vendas";
import obra from "./obra";
import seguro from "./Seguro";
import fabricacao from "./fabricacao";
import config from "../config";
import field from "./FieldServices";
import automacao from "./Automacao";
import contrato from "./contrato";
import projetos from "./projetos";
import produto from "./produto";
import avisos from "./avisos";
import sgi from "./sgi";
import diretorio from "./Diretorio"

import cliente from "./cliente";
import controle_acesso from "./controle_acesso";
import projetos_fabrica from "./projetos_fabrica";
import materiais from "./materiais";
import juridico from "./Juridico";


export let isCliente = false;

export default function defineAbilityFor(user: any) {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  if (user.email) {
    if (user.temPermissao(["acesso_total"])) can("manage", "all");
    if (user.temPermissao(["mkt_read"])) can("read", "all");

    if (user.temPermissao(["dev_acesso_total"]) && config.AMBIENTE == "dev")
      can("manage", "all");
  }

  const defaultRules = build();
  let rules = [
    ...defaultRules.rules,
  ]
  if (user && user.temPermissao(['cliente'])) {
    isCliente = true;
    rules = [...rules, ...cliente(user).rules]
  } else if (user) {
    rules = [
      ...rules, 
      ...rdo(user).rules,
      ...obra(user).rules,
      ...seguro(user).rules,
      ...pos_vendas(user).rules,
      ...field(user).rules,
      ...automacao(user).rules,
      ...contrato(user).rules,
      ...avisos(user).rules,
      ...sgi(user).rules,
      ...produto(user).rules,
      ...diretorio(user).rules,
      ...controle_acesso(user).rules,
      ...projetos(user).rules,
      ...projetos_fabrica(user).rules,
      ...materiais(user).rules,
      ...fabricacao(user).rules,
      ...juridico(user).rules,
    ]

  }
  return createMongoAbility([
    ...rules
    // ...defaultRules.rules,
    // ...rdo(user).rules,
    // ...obra(user).rules,
    // ...seguro(user).rules,
    // ...pos_vendas(user).rules,
    // ...field(user).rules,
    // ...automacao(user).rules,
    // ...contrato(user).rules,
    // ...avisos(user).rules,
    // ...sgi(user).rules,
    // ...diretorio(user).rules,
    // ...controle_acesso(user).rules,
    // ...projetos(user).rules,
    // ...projetos_fabrica(user).rules,
    // ...materiais(user).rules,
    // ...cliente(user).rules,
    // ...fabricacao(user).rules,
    // ...juridico(user).rules,
  ]);
}

export function can(action: string, subject: any, field?: any) {
  const user = userStore().user;
  const ability = defineAbilityFor(user);
  return ability.can(action, subject, field);
}

export function cannot(action: string, subject: string, field?: any) {
  return !can(action, subject, field);
}

// userAbility.can('create', 'DIARIO_OS', { obra: router.params.obra })
